<template>
    <div>
        <b-row>
            <b-col cols="12" class="d-flex justify-content-center mt-4 mb-4">
                <b-button-group>
                    <b-button variant="primary" @click="makePresidentApplication">{{$t('club_president_request')}}</b-button>
                    <b-button variant="light" @click="cancelPresidentApplication">{{$t('club_president_request_cancel')}}</b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Component

    //Other

    //Service
    import StudentClubService from "@/services/StudentClubService"

    export default {
        props: {
            clubData: {
                type: Object,
            }
        },

        components: {

        },

        data() {
            return {

            }
        },

        methods: {
            makePresidentApplication(){
                StudentClubService.makePresidentApplication(this.clubData.student_club_id).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                }).catch(e => {
                    this.showErrors(e, null)
                })
            },

            cancelPresidentApplication(){
                StudentClubService.cancelPresidentApplication(this.clubData.student_club_id).then(response => {
                    this.$toast.success(this.$t('api.'+response.data.message))
                }).catch(e => {
                    this.showErrors(e, null)
                })
            }
        },

        created() {

        },

    }
</script>
